import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getJournalists } from '../api/strapiClient';

export default function Journalists() {
  const [journalists, setJournalists] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);

    getJournalists()
      .then((res) => {
        if (!cancelled) setJournalists(res.data || []);
      })
      .catch((err) => {
        if (!cancelled) setError(err.message || 'Unknown error');
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <main className="page">
      <section className="hero">
        <p className="hero__eyebrow">The newsroom</p>
        <h1 className="hero__title">Journalists</h1>
        <p className="hero__subtitle">
          The bylines behind the wire — writers and outlets we pull stories from.
        </p>
      </section>

      {error && (
        <div className="state-message state-message--error">
          Couldn't reach the newsroom. {error}
        </div>
      )}
      {!error && loading && <div className="state-message">Loading journalists…</div>}
      {!error && !loading && !journalists.length && (
        <div className="state-message">No journalists on file yet.</div>
      )}

      {!error && !loading && journalists.length > 0 && (
        <div className="journalist-list">
          {journalists.map((journalist) => {
            const { firstName, lastName, publications } = journalist;
            const journalistPublications = publications || [];
            return (
              <Link
                key={journalist.id}
                to={`/journalists/${journalist.documentId}`}
                className="journalist-list__item"
              >
                <span className="journalist-list__name">
                  {firstName} {lastName}
                </span>
                {journalistPublications.length > 0 && (
                  <span className="journalist-list__publications">
                    {journalistPublications.map((pub) => pub.name).join(', ')}
                  </span>
                )}
              </Link>
            );
          })}
        </div>
      )}
    </main>
  );
}
